<template>
  <div class="symposium-session-detail">

    <div style="background-color: white;margin-top: -44px;">
      <b-container>
        <a v-if="isMobile" :href="`/symposium/sessions/${stageDetial?.id}`"
          style="display: inline-flex; align-items: center; gap: 16px; background-color: #fff; margin-top: 10px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="#828282" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span style="color: #828282;">
            Back to {{ sessionDetial?.name }}
          </span>
        </a>
        <b-breadcrumb v-else style="background-color: #fff;">
          <b-breadcrumb-item href="/symposium/sessions" class="cus-breadcrumb">All Session</b-breadcrumb-item>
          <b-breadcrumb-item :href="`/symposium/sessions/${stageDetial?.id}`" class="cus-breadcrumb">
            {{ stageDetial?.name }}
          </b-breadcrumb-item>
          <b-breadcrumb-item href="#" active class="cus-breadcrumb-active">{{ sessionDetial?.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-container>
    </div>

    <b-container>
      <div v-if="sessionDetial && stageDetial" class="session-detail">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <h1 class="title-hall">{{ stageDetial.name }}</h1>
          <button @click="clickToVideoDetail(stageDetial.id)" class="watch-past-btn"
            v-if="watchPastBtn && watchPastBtn.isDisplay">
            {{ watchPastBtn.name }}
          </button>
        </div>
        <img loading="lazy" class="image" v-if="sessionDetial.thumbnail"
          :src="`${baseURL}/storage/app/img/symposium/${sessionDetial.thumbnail}`" :alt="sessionDetial.name">
        <img loading="lazy" class="image" v-else src="@/assets/images/symposium/image_placehoder.png"
          :alt="sessionDetial.name" />
        <div class="description">
          <div class="time"> {{ sessionDetial.time_start }} - {{ sessionDetial.time_end }}</div>
          <h1 class="subtitle">{{ sessionDetial.name }}</h1>
          <div class="synopsis" v-if="sessionDetial.content">
            <h3>Synopsis :</h3>
            <div v-html="sessionDetial.content"></div>
          </div>
          <div class="speaker" v-if="sessionDetial.speakers">
            <h3>Speakers :</h3>
            <div v-html="sessionDetial.speakers"></div>
          </div>
        </div>
      </div>
      <div class="other-stage">
        <!-- <h1 class="title">{{ symposiumOtherTitle }} - {{ currentSesstion.title }}</h1> -->
        <SessionCarousel v-for="(slider, sliderIndex) in currentSesstion.data" :key="`slider${sliderIndex}`"
          v-show="slider.id == $route.params.mainId" :slider="slider" :sliderKey="`sliderKey${sliderIndex}`"
          :slideKey="`slideKey${sliderIndex}`" :titleName="`${stageDetial.name} - ${currentSesstion.title}`"
          deduped="true" />
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

// const SchoolOfCreativityDetail = () =>
//   import('@/components/Creativity/SchoolOfCreativityDetail')

const SessionCarousel = () => import('@/components/SessionCarousel')

// custom day
// schoolCreative.id for day
const day1 = [1, 2, 3, 4, 5]
const day2 = [6, 7, 8, 9, 10]

export default {
  components: {
    SessionCarousel
    // SchoolOfCreativityDetail,
  },

  data () {
    return {
      sectionData: [],
      sessionId: 1,
      sessionData: [],
      sectionData2: [
        {
          title: '15 NOV',
          data: []
        },
        {
          title: '16 NOV',
          data: []
        }
      ],
      testhtml: ` <ul>
    <li>ทสร บุณยเนตร<br>Chief Creative Officer BBDO Bangkok</li>
    <li>ดมิสาฐ์ องค์ศิริวัฒนา<br>Co-Founder & Chief Creative Officer Sour Bangkok</li>
    <li>ต่อศักดิ์ ชื่นประภา<br>Co-Founder & Chief Creative Officer Wolf BKK</li>
    <li>ภาคย์ วรรณศิริ<br>Chief Creative Officer Wunderman Thompson Thailand</li>
    <li>ดิศรา อุดมเดช<br>Founder & CEO Yell Group (Moderator)</li>
  </ul>`,
      currentSlide: 0,
      slidesPerView: 4,
      gap: 5
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      schoolCreativesRaw: (state) => state.creativity.schoolCreatives
    }),
    symposiumOtherTitle () {
      const mConfig = this.configMap.get('symposiumOtherTitle')
      return mConfig ? mConfig.name : 'Other Stage'
    },
    breadcrumbs () {
      return [
        {
          text: 'All Session',
          href: '/symposium/sessions'
        },
        {
          text: this.stageDetial?.name,
          href: `/symposium/sessions/${this.stageDetial?.id}`
        },
        {
          text: this.sessionDetial?.name,
          href: '#',
          active: true
        }
      ]
    },
    currentSesstion () {
      const { mainId } = this.$route.params
      if (day1.includes(parseInt(mainId))) {
        return this.sectionData2[0]
      } else if (day2.includes(parseInt(mainId))) {
        return this.sectionData2[1]
      }
      return null
    },
    nextSesstion () {
      const { mainId } = this.$route.params
      if (day1.includes(parseInt(mainId))) {
        return this.sectionData2[1]
      } else if (day2.includes(parseInt(mainId))) {
        return this.sectionData2[0]
      }
      return null
    },
    stageDetial () {
      const { mainId } = this.$route.params
      return this.currentSesstion.data.filter((d) => d.id === parseInt(mainId)).pop()
    },
    sessionDetial () {
      const { mainId, sessionId } = this.$route.params
      return this.currentSesstion.data.filter((d) => d.id === parseInt(mainId)).pop()?.detail.filter((d) => d.id === parseInt(sessionId)).pop()
    },
    watchPastBtn () {
      return this.configMap.get('watchPastBtn')
    }
  },

  methods: {
    clickToVideoDetail (videoId) {
      sessionStorage.setItem('symposium_redirect_video_detail_id', videoId)
      window.open(`/symposium/video/${videoId}`, '_blank')
    },

    clickSession (sessionItem) {
      const { mainId } = this.$route.params

      this.$router.push({
        name: 'SymposiumSessionDetail',
        params: {
          mainId: mainId,
          sessionId: sessionItem.id
        }
      })
    },

    mapSection (data) {
      this.sectionData = []
      this.sectionData2[0].data = []
      this.sectionData2[1].data = []

      const stageDay1 = this.configMap.get('symposiumStageDay1')
      this.sectionData2[0].image = stageDay1?.isDisplay ? stageDay1?.image : null
      this.sectionData2[0].title = stageDay1?.isDisplay && stageDay1.name ? stageDay1.name : this.sectionData2[0].title

      const stageDay2 = this.configMap.get('symposiumStageDay2')
      this.sectionData2[1].image = stageDay2?.isDisplay ? stageDay2?.image : null
      this.sectionData2[1].title = stageDay2?.isDisplay && stageDay2.name ? stageDay2?.name : this.sectionData2[1].title

      data.forEach((schoolCreative) => {
        const obj = {
          id: schoolCreative.id,
          name: schoolCreative.name,
          room: schoolCreative.room,
          imgUrl: `${this.baseURL}/storage/app/img/creativeDay/${schoolCreative.image}`,
          description: schoolCreative.description,
          detail: schoolCreative.detail
        }

        // mapSection day 1
        if (day1.includes(schoolCreative.id)) {
          this.sectionData2[0].data.push(obj)
        }

        // mapSection day 2
        if (day2.includes(schoolCreative.id)) {
          this.sectionData2[1].data.push(obj)
        }

        this.sectionData.push(obj)
      })
    },

    mapSession (id, data) {
      this.sessionData = []

      if (data) {
        data.forEach((schoolCreative) => {
          if (id === schoolCreative.id) {
            schoolCreative.detail.forEach((detail) => {
              this.sessionData.push(detail)
            })
          }
        })
      }
    },

    clickSection (session) {
      this.$router.push({
        name: 'SymposiumStageDetail',
        params: {
          mainId: session.id
        }
      })
    },

    clickDetail () {
      this.mapDetail(this.schoolCreativesRaw)
    }

  },

  watch: {
    schoolCreativesRaw (data) {
      if (data) {
        this.mapSection(data)
      }
    },

    sectionData (data) {
      if (data) {
        this.mapSession(this.sessionId, this.schoolCreativesRaw)
      }
    },

    schoolCreativeDetail (data) {
      this.mapDetail(data)
    }
  },

  created () {
    this.$store.dispatch('creativity/getSchoolCreativity')
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.watch-past-btn {
  background-color: #EE0300;
  color: #ffffff;
  padding: 8px 16px;
  margin: 0;
  font-size: 24px;
}

@media (max-width: 600px) {
  .watch-past-btn {
    font-size: 16px;
    padding: 4px 8px;
  }
}

.cus-breadcrumb {
  color: #808285;
  text-align: center;
  font-family: var(--button-default-font-family, "DB Adman X");
  font-size: var(--button-default-font-size, 20px);
  font-style: normal;
  font-weight: var(--button-default-font-weight, 400);
  line-height: normal;
}

.cus-breadcrumb-active {
  color: #DA0401;
  text-align: center;
  font-family: var(--button-emphasis-font-family, "DB Adman X");
  font-size: var(--button-emphasis-font-size, 20px);
  font-style: normal;
  font-weight: var(--button-emphasis-font-weight, 700);
  line-height: normal;
}

.symposium-session-detail {
  padding-top: 44px;
  padding-bottom: 22px;

  .session-detail {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .image {
      aspect-ratio: 16 / 9;
    }

    .synopsis {

      h3 {
        color: var(--baseColor-neutral-1000, #000);
        /* h3-subtitle */
        font-family: var(--h3-font-family, "DB HelvethaicaMon X");
        font-size: var(--h3-font-size, 28px);
        font-style: normal;
        font-weight: var(--h3-font-weight, 500);
        line-height: normal;
      }

      div {
        color: var(--baseColor-neutral-1000, #000);
        font-family: var(--body-upscale-font-family, Sarabun);
        font-size: var(--body-default-font-size, 16px);
        font-style: normal;
        font-weight: var(--body-upscale-font-weight, 400);
        line-height: normal;
      }
    }

    .speaker {

      h3 {
        color: var(--baseColor-neutral-1000, #000);
        font-family: var(--h3-font-family, "DB HelvethaicaMon X");
        font-size: var(--h3-font-size, 28px);
        font-style: normal;
        font-weight: var(--h3-font-weight, 500);
        line-height: normal;
      }

      div {
        color: var(--baseColor-neutral-1000, #000);
        font-family: var(--body-upscale-font-family, Sarabun);
        font-size: var(--body-default-font-size, 16px);
        font-style: normal;
        font-weight: var(--body-upscale-font-weight, 400);
        line-height: normal;
        padding: var(--space-00, 0px) var(--space-02, 20px);
      }

    }

    .description {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding-bottom: 44px;
    }

    .title-hall {
      color: #212529;
      font-family: var(--h3-font-family, "DB HelvethaicaMon X");
      font-size: var(--h3-font-size, 48px);
      font-style: normal;
      font-weight: var(--h3-font-weight, 500);
      line-height: normal;
    }

    .subtitle {
      color: var(--baseColor-neutral-1000, #000);
      font-family: var(--h2-font-family, "DB HelvethaicaMon X");
      font-size: var(--h2-font-size, 60px);
      font-style: normal;
      font-weight: var(--h2-font-weight, 700);
      line-height: normal;
    }

    .time {
      display: flex;
      padding: var(--space-02, 8px) var(--space-04, 16px);
      align-items: center;
      gap: var(--space-04, 16px);
      align-self: stretch;
      background: #DA0401;
      color: #FFF;

      /* h6-topic */
      font-family: var(--h6-font-family, "DB HelvethaicaMon X");
      font-size: var(--h6-font-size, 28px);
      font-style: normal;
      font-weight: var(--h6-font-weight, 500);
      line-height: normal;
      max-width: 365px;
    }
  }

  .other-stage {
    margin-bottom: 44px;

    h1.title {
      color: #212529;

      /* h5-subheading */
      font-family: var(--h5-font-family, "DB HelvethaicaMon X");
      font-size: var(--h5-font-size, 32px);
      font-style: normal;
      font-weight: var(--h5-font-weight, 500);
      line-height: normal;
      margin-bottom: 24px;

    }
  }

  @media (max-width: 600px) {

    .cus-breadcrumb {
      font-size: var(--body-upscale-font-size, 16px);
    }

    .cus-breadcrumb-active {
      font-size: var(--body-upscale-font-size, 16px);
    }

    .session-detail {

      .synopsis {

        h3 {
          font-size: var(--h3-font-size, 24px);
        }

        div {
          font-size: var(--body-upscale-font-size, 16px);
        }
      }

      .speaker {

        h3 {
          font-size: var(--h3-font-size, 24px);

        }

        div {
          font-size: var(--body-upscale-font-size, 16px);

        }

      }

      .title-hall {
        font-size: var(--h3-font-size, 24px);
      }

      .subtitle {
        font-size: var(--h2-font-size, 32px);
      }

      .time {
        font-size: var(--h6-font-size, 16px);
        width: 100%;
        max-width: 100%;
      }
    }

    .other-stage {

      h1.title {
        font-size: var(--h3-font-size, 24px);
      }
    }
  }

}
</style>
